<div id="home-3" class="page-layout simple">
    <div class="content p-16">
        <mat-expansion-panel [expanded]="true" fxLayout="column" fxLayoutAlign="center" class="mb-16">
            <mat-expansion-panel-header class="header accent" style="min-height: 64px" fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column" fxLayoutAlign="center start">
                    <div class="h2">PORT {{data.pol.name}} TO PORT {{data.pod.name}}</div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="secondary-text">Transit time: {{data.transit_time}} day{{data.transit_time > 1 ? 's' : '' }}</span>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="16" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Vessel</div>
                            <div class="font2 mt-8">{{data.vessel.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="12" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Voyage</div>
                            <div class="font2 mt-8">{{data.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="21" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Load terminal</div>
                            <div class="font2 mt-8">{{data.load_terminal.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="15" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Depart time</div>
                            <div class="font2 mt-8">{{data.depart_time | date : 'MM/dd/yyyy hh:mm a'}}</div>
                        </div>
                    </div>
                </div>
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="21" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Discharge terminal</div>
                            <div class="font2 mt-8">{{data.discharge_terminal.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="course" fxFlex="50"
                    fxFlex.gt-md="15" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <div class="" fxLayout="column" fxFlex="1 1 auto">
                        <div class="mt-16" fxLayout="column" fxLayoutAlign="start" fxFlex="1 1 auto">
                            <div class="font1" style="font-weight: bold">Arrive time</div>
                            <div class="font2 mt-8">{{data.arrive_time | date : 'MM/dd/yyyy hh:mm a'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <fcl-price-list></fcl-price-list>
    </div>
</div>


